var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('menu-navigation');
import { breakpoints, theme } from '@shapeable/theme';
import { MenuItemLink } from './menu-item-link';
import { trim, filter, get } from 'lodash';
import { useActiveEntity } from '../hooks/use-active-entity';
export var MenuNavigationDividerColors = {
  default: 'text-subtle',
  inverted: 'light'
};
export var MenuNavigationDefaultProps = {
  spacing: 3,
  stackedSpacing: 3,
  inset: 2,
  stackOnMobile: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: stretch;\n    line-height: 1.15em;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: stretch;\n    line-height: 1.15em;\n  "])))
});
var ItemsStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    list-style: none;\n    flex-grow: 1;\n    display: flex;\n    align-items: stretch;\n\n    ", "\n  "], ["\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    list-style: none;\n    flex-grow: 1;\n    display: flex;\n    align-items: stretch;\n\n    ", "\n  "])), function (_a) {
    var stackOnMobile = _a.stackOnMobile;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      flex-direction: ", ";\n      align-items: ", ";\n    "], ["\n      flex-direction: ", ";\n      align-items: ", ";\n    "])), stackOnMobile ? 'column' : 'row', stackOnMobile ? 'flex-start' : 'stretch');
  }),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    justify-content: flex-end;\n    flex-wrap: wrap;\n    flex-direction: row;\n    align-items: stretch;\n  "], ["\n    justify-content: flex-end;\n    flex-wrap: wrap;\n    flex-direction: row;\n    align-items: stretch;\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: stretch;\n    box-sizing: border-box;\n    ", "\n\n    ", "\n\n    &:first-child {\n      margin-left: 0;\n    }\n  "], ["\n    margin: 0;\n    padding: 0;\n    display: flex;\n    align-items: stretch;\n    box-sizing: border-box;\n    ", "\n\n    ", "\n\n    &:first-child {\n      margin-left: 0;\n    }\n  "])), function (_a) {
    var stackOnMobile = _a.stackOnMobile;
    return stackOnMobile && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      width: 100%;\n    "], ["\n      width: 100%;\n    "])));
  }, function (_a) {
    var spacing = _a.spacing,
      stackedSpacing = _a.stackedSpacing,
      inset = _a.inset,
      stackOnMobile = _a.stackOnMobile;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      flex-direction: ", ";\n      padding: ", " 0 0;\n      margin-left: ", ";\n    "], ["\n      flex-direction: ", ";\n      padding: ", " 0 0;\n      margin-left: ", ";\n    "])), stackOnMobile ? 'column' : 'row', theme.UNIT(stackOnMobile ? stackedSpacing : 0), theme.UNIT(stackOnMobile ? 0 : spacing));
  }),
  desktop: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    flex-direction: row;\n    margin-bottom: ", ";\n    padding-top: 0;\n    width: auto;\n    ", "\n  "], ["\n    flex-direction: row;\n    margin-bottom: ", ";\n    padding-top: 0;\n    width: auto;\n    ", "\n  "])), theme.UNIT(4), function (_a) {
    var spacing = _a.spacing;
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), theme.UNIT(spacing));
  })
});
var LinkStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    white-space: nowrap;\n    ", "\n\n    li:last-child & {\n      margin-right: 0;\n    }\n  "], ["\n    white-space: nowrap;\n    ", "\n\n    li:last-child & {\n      margin-right: 0;\n    }\n  "])), function (_a) {
    var spacing = _a.spacing,
      stackOnMobile = _a.stackOnMobile,
      stackedSpacing = _a.stackedSpacing,
      inset = _a.inset;
    return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      align-self: ", ";\n      padding: 0 ", " 0;\n      margin-right: ", ";\n      margin-bottom: ", ";\n    "], ["\n      align-self: ", ";\n      padding: 0 ", " 0;\n      margin-right: ", ";\n      margin-bottom: ", ";\n    "])), stackOnMobile ? 'flex-start' : 'center', theme.UNIT(stackOnMobile ? inset : 0), theme.UNIT(stackOnMobile ? 0 : spacing), theme.UNIT(stackOnMobile ? stackedSpacing : 0));
  }),
  desktop: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    align-self: center;\n    padding: 0;\n    margin-bottom: 0;\n    ", "\n\n    li:last-child & {\n      margin-right: 0;\n    }\n  "], ["\n    align-self: center;\n    padding: 0;\n    margin-bottom: 0;\n    ", "\n\n    li:last-child & {\n      margin-right: 0;\n    }\n  "])), function (_a) {
    var spacing = _a.spacing;
    return css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      margin-right: ", ";\n    "], ["\n      margin-right: ", ";\n    "])), theme.UNIT(spacing));
  })
});
var DividerStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var _color = _a._color,
      stackOnMobile = _a.stackOnMobile;
    return css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      ", ";\n      width: ", ";\n      height: ", ";\n      display: block;\n      align-self: stretch;\n      justify-self: stretch;\n    "], ["\n      ", ";\n      width: ", ";\n      height: ", ";\n      display: block;\n      align-self: stretch;\n      justify-self: stretch;\n    "])), theme.DOT_BG(stackOnMobile ? 'h' : 'v', _color), stackOnMobile ? '100%' : '2px', stackOnMobile ? '2px' : '100%');
  }),
  desktop: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    ", "\n    width: 2px;\n    height: 100%;\n  "], ["\n    ", "\n    width: 2px;\n    height: 100%;\n  "])), function (_a) {
    var _color = _a._color;
    return css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme.V_DOT_BG(_color));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Items: styled.ul.attrs(cls.attr('items'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled.li.attrs(cls.attr('item'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Link: styled(MenuItemLink)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Divider: styled.span.attrs(cls.attr('divider'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), DividerStyles)
};
export var MenuNavigation = function (props) {
  var className = props.className,
    variant = props.variant,
    entity = props.entity,
    onLinkClick = props.onLinkClick,
    spacing = props.spacing,
    stackedSpacing = props.stackedSpacing,
    showDividers = props.showDividers,
    inset = props.inset,
    dividerColor = props.dividerColor,
    stackOnMobile = props.stackOnMobile,
    color = props.color,
    activeColor = props.activeColor,
    hoverColor = props.hoverColor;
  var _a = entity.items,
    items = _a === void 0 ? [] : _a;
  var linkVariant = props.linkVariant || variant;
  var currentEntity = useActiveEntity();
  var onClick = function (entity) {
    return function (event) {
      onLinkClick(event, entity);
    };
  };
  var itemsToShow = filter(items, function (item) {
    if (item.page && item.page.disabled) {
      return null;
    }
    // assume this nav is not used for the header, which will be handled in a different component
    if (!get(item, 'path', get(item, 'page.path'))) {
      return null;
    }
    return item;
  });
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Items, {
    stackOnMobile: stackOnMobile
  }, itemsToShow.map(function (item, index) {
    return React.createElement(My.Item, {
      inset: inset,
      stackOnMobile: stackOnMobile,
      spacing: spacing,
      stackedSpacing: stackedSpacing,
      showDividers: showDividers,
      key: item.id
    }, React.createElement(My.Link, {
      onClick: onLinkClick && onClick(item),
      stackOnMobile: stackOnMobile,
      isActive: trim(item.path) !== '' && trim(currentEntity && currentEntity.path, '/') === trim(item.path, '/'),
      inset: inset,
      spacing: spacing,
      stackedSpacing: stackedSpacing,
      variant: linkVariant,
      entity: item
    }), showDividers && index !== itemsToShow.length - 1 && (props.divider || React.createElement(My.Divider, {
      stackOnMobile: stackOnMobile,
      _color: dividerColor || MenuNavigationDividerColors[variant]
    })));
  })));
};
MenuNavigation.defaultProps = MenuNavigationDefaultProps;
MenuNavigation.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22;